import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getActiveMenuByOffice = ({ user }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.queries.get,
    variables: {
      officeName: user.officeName,
    },
  });

const findMenuEventsByWeek = ({ startDate, endDate, office }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.queries.getByWeek,
    variables: {
      startDate,
      endDate,
      office,
    },
  });

const findMenuEvent = ({ date, event, office }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.queries.get,
    variables: {
      date,
      event,
      office,
    },
  });

const addMeal = (name) =>
  graphqlHelper({
    query: graphql.weeklyMenu.mutations.addMeal,
    variables: {
      name,
    },
  });

const addMenuEvent = ({ office, date, event, time }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.mutations.addMenuEvent,
    variables: {
      office,
      date,
      event,
      time,
    },
  });

const addMenuEventMeal = ({ meal, menuEvent }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.mutations.addMenuEventMeal,
    variables: {
      meal,
      menuEvent,
    },
  });

const editMeal = ({ id, name }) =>
  graphqlHelper({
    query: graphql.weeklyMenu.mutations.editMeal,
    variables: {
      id,
      name,
    },
  });

const saveWeeklyMenu = (menuEvents) =>
  graphqlHelper({
    query: graphql.weeklyMenu.mutations.saveWeeklyMenu,
    variables: {
      menu: {
        menuEvents,
      },
    },
  });

export {
  getActiveMenuByOffice,
  findMenuEventsByWeek,
  findMenuEvent,
  addMeal,
  addMenuEvent,
  addMenuEventMeal,
  editMeal,
  saveWeeklyMenu,
};



// WEBPACK FOOTER //
// ./src/services/weeklyMenu.js